export function accordionLinks() {
    // Remove href="#" to prevent scrolling to top
    $('.ea-header a[href="#"]').removeAttr('href');
	$('.ea-header a[href="#"]').attr('data-no-swup', true);
	console.log('here');
    // css fix to add link cursor
    $('.ea-header a').css('cursor', 'pointer');
}



// WEBPACK FOOTER //
// ./scripts/modules/accordionLinks.js